import {
  ApolloClient,
  NormalizedCacheObject,
  ApolloLink,
  concat,
  InMemoryCache,
  HttpLink,
} from '@apollo/client';
import { envs } from '../common/config';
import { supabase } from './supabase';

const option = {
  typePolicies: {
    Query: {
      fields: {},
    },
  },
};

const httpLink = new HttpLink({
  uri: envs.BackendUrl,
  fetchOptions: {
    credentials: 'omit',
  },
});

const createAuthMiddleware = () =>
  new ApolloLink((operation, forward) => {
    operation.setContext(async ({ headers = {} }: { headers: Record<string, string> }) => {
      const { data: { session } } = await supabase.auth.getSession();
      const token = session?.access_token;

      return {
        headers: {
          ...headers,
          apikey: envs.supabaseAnonKey,
          ...(token ? { authorization: `Bearer ${token}` } : {}),
        },
      };
    });

    return forward(operation);
  });

export function createClient() {
  const client = new ApolloClient<NormalizedCacheObject>({
    link: concat(createAuthMiddleware(), httpLink),
    cache: new InMemoryCache(option),
    defaultOptions: {
      query: {
        fetchPolicy: 'network-only',
      },
    },
  });

  return client;
}
